import { render, staticRenderFns } from "./AppSteps.vue?vue&type=template&id=18625c43&scoped=true&"
import script from "./AppSteps.vue?vue&type=script&lang=ts&"
export * from "./AppSteps.vue?vue&type=script&lang=ts&"
import style0 from "./AppSteps.vue?vue&type=style&index=0&id=18625c43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18625c43",
  null
  
)

export default component.exports